import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import img from "../../assets/images/review/google.png";
import registerGraphic from '../../assets/images/khojgraphics/khoj1.png'
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import OTPInput from "react-otp-input";
import { Modal } from "react-bootstrap";
import fetch_axios from "axios";
import { useGoogleLogin } from "@react-oauth/google";
import axios, { PublicKey } from "../../API/axios";
import toast from "react-hot-toast";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { Helmet } from "react-helmet";



function SignIn() {

  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [displays, setDisplays] = useState(false);
  // const [flag, setFlag] = useState(false);
  const [confimationFlag, setConfimationFlag] = useState(false);
  console.log('confimationFlag', confimationFlag);

  const handleClose = () => {
    setConfimationFlag(false);
  };
  const [otp, setOtp] = useState("");
  const handleChangeOtp = (otp) => setOtp(otp);

  const [minutes, setMinutes] = useState(1)
  const [seconds, setSeconds] = useState(30)
  const handleSubmitMail = async (e) => {
    const body = {
      email: email
    }
    try {
      await axios
        .post(
          `Auth/ConfirmAccountByEmail`, body
        )
        .then((res) => {
          console.log("res", res);
          toast.success(res.data.message);
          setConfimationFlag(false)
        });
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };



  // useEffect(() => {
  // 	const interval = setInterval(() => {
  // 		if (seconds > 0) {
  // 			setSeconds(seconds - 1);
  // 		}

  // 		if (seconds === 0) {
  // 			if (minutes === 0) {
  // 				clearInterval(interval);
  // 			} else {
  // 				setSeconds(59);
  // 				setMinutes(minutes - 1);
  // 			}
  // 		}
  // 	}, 1000);

  // 	return () => {
  // 		clearInterval(interval);
  // 	};
  // 	// eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [seconds]);


  //  google Api.... 
  const externalLogin = async (responseData) => {
    try {
      const res = await
        axios
          .post("/Auth/ContinueWithGoogle", responseData,
            {
              headers: {
                PublicKey,
              },
            }
          );
      toast.success(res.data.message)
      const userData = res.data.responseData.profile;
      localStorage.setItem('entityName',userData.entityName);
      // localStorage.setItem('firstName', userData.firstName);
			// localStorage.setItem('lastName', userData.lastName);
      localStorage.setItem('email', userData.email);
      localStorage.setItem('token', userData.token);
      localStorage.setItem('userUID', userData.userUID);
      localStorage.setItem('userType', userData.userType);
      localStorage.setItem('sessionId', userData.sessionId);
      localStorage.setItem('ProfileImage', userData.userImage);
      localStorage.setItem('Module', userData.userType);
      if (userData.userType === 'Candidate') {
        navigate('/Home')
      } else if (userData.userType === 'Institution') {
        navigate('/Home')
      } else if (userData.userType === 'Company') {
        navigate('/Home')
      } else if (userData.userType === 'Recruiter') {
        navigate('/Home')
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.error(error.response.data.message)
      } else {
        toast.error(error.response.data.message)
      }
    }
  };
  const googleSignin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const resp = await fetch_axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          }
        );
        const responseData = {
          "userType": null,
          "email": resp.data.email,
          "externalLoginId": resp.data.sub,
          "firstName": resp.data.given_name,
          "lastName": resp.data.family_name,
        };

        externalLogin(responseData);
      } catch (error) {
        console.log(error);
      }
    },
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loginData, setLoginData] = useState(null);

  const LoginwithEmail = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    if (!email || !password) {
      toast.error("Please enter required fields!");
      return;
    }

    try {
      setDisplays(true);
      setIsSubmitting(true);

      // Step 1: Encode email and password to Base64
      const firstPayload = JSON.stringify({ email, password });
      const firstEncoded = btoa(firstPayload);

      // Step 2: Encode second payload with SecretKey
      const secretKey = "uwoETqyKJsOnH7dipuxEVhO+MmWZutnubwQPyLCiJKY=";
      const secondPayload = JSON.stringify({
        Result: firstEncoded,
        SecretKey: secretKey
      });
      const secondEncoded = btoa(secondPayload);

      // Step 3: Send the second API request
      const finalRes = await axios.post("/Auth/Sign_In", { data: secondEncoded }, {
        headers: { PublicKey }
      });

      // Handle cnddtTests data

      const candList = finalRes.data.responseData.cnddtTests || [];
      setLoginData(candList);
      console.log("cnddtTests:", candList);
      console.log("loginData updated:", candList);
      console.log(loginData, "llllllllllllll")

      if (finalRes.data.responseData.emailConfirmed === false) {
        setConfimationFlag(true);
      } else {
        toast.success(finalRes.data.message);
        const userData = finalRes.data.responseData.profile;
        const userCandData = finalRes.data.responseData.cnddtTests;
        console.log("userData====>",userData)
        localStorage.removeItem('userCandData');
        localStorage.setItem('userCandData', JSON.stringify(userCandData));
        localStorage.setItem('entityName',userData.entityName);
        localStorage.setItem('firstName', userData.firstName);
			  localStorage.setItem('lastName', userData.lastName);
        localStorage.setItem('email', userData.email);
        localStorage.setItem('token', userData.token);
        localStorage.setItem('userUID', userData.userUID);
        localStorage.setItem('userType', userData.userType);
        localStorage.setItem('sessionId', userData.sessionId);
        localStorage.setItem('ProfileImage', userData.userImage);
        localStorage.setItem('Module', userData.userType);
        navigate('/Home');
      }
    } catch (error) {
      console.error("Error:", error);

      if (error.response) {
        const { status, data } = error.response;
        if (error.response.data.responseData?.emailConfirmed === false) {
          setConfimationFlag(true);
        } else {
          toast.error(data.message || "An unexpected error occurred");
        }

        if (status === 404) {
          console.log("Error: Account not found!");
        } else if (status === 302) {
          console.log("Error: Redirect detected!", error.response.data.responseData?.emailConfirmed);
        } else {
          console.log("Unhandled response status");
        }
      } else {
        console.log("Error: Network or unknown error");
        toast.error("An error occurred. Please try again later.");
      }
    } finally {
      setIsSubmitting(false); // Re-enable after API is done
    }
  };


  useEffect(() => {
    if (loginData) {
      console.log("loginData is updated: ", loginData);
    }
  }, [loginData]);

  console.log("loginData is updated: ", loginData);


  return (
    <>
      <Helmet>
        <title>Login | Jobkikhoj</title>
        {/* <meta name="description" content="WeLink Jobs, one of the most trusted job search sites, empowering your career journey. Connect seamlessly for free job posting and social networking." />
              <meta name="keywords" content="newsfeed, updates, Latest Blogs" />
              <meta property="og:title" content="WeLink Jobs | Best Social Media Platform For Job Search" />
              <meta property="og:description" content="WeLink Jobs, one of the most trusted job search sites, empowering your career journey. Connect seamlessly for free job posting and social networking." /> */}
        <meta property="og:url" content="https://jobkikhoj.com" />
      </Helmet>
      <section className="account-section pt-4">
        <div className="container">
          <div className="row">
            <div className="col-md-6 registerGraphics non-login-registerGraphics">
              <img src={registerGraphic} width={"80%"} />
            </div>
            <div className="col-md-6 text-center">
              <h4 className="mt-3">Login</h4>
              <div className="wd-form-login tf-tab">
                <Link to="#" className="btn-social" onClick={() => googleSignin()}>
                  <img src={img} alt="images" /> Continue with Google
                </Link>
                <p className="line-ip my-4">
                  <span>or</span>
                </p>

                <form action="/">
                  <div className="ip text-transform-email">
                    <label>Email Address <span>*</span></label>
                    <input
                      type="text"
                      placeholder="Email Id"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      id="email"
                      name="email"
                      className="Input-SignIn"
                      invalid={displays && email === ''}

                    />
                    {displays && !email ? <span className='error_msg_lbl text-red'>Enter Email Address </span> : null}

                  </div>

                  <div className="ip">
                    <label>Password <span>*</span></label>
                    <div className="inputs-group auth-pass-inputgroup">
                      <input
                        type={showPass ? "text" : "password"}
                        className="input-form password-input"
                        placeholder="Password"
                        // maxLength={10}
                        id="password-input"
                        name="password"
                        required
                        onChange={(e) => setPassword(e.target.value)}
                        //value={password}
                        invalid={displays && password === ''}
                      />
                      {displays && !password ? <span className='error_msg_lbl text-red'>Enter Password </span> : null}

                      <Link
                        className={`password-addon ${showPass ? "icon-eye" : "icon-eye-off"
                          }`}
                        id="password-addon"
                        onClick={() => setShowPass(!showPass)}
                      />
                    </div>
                  </div>
                  <div className="group-ant-choice">
                    <Link to="/Forgot-password" className="forgot">
                      Forgot password?
                    </Link>
                  </div>
                  {/* <Link to='/Home' onClick={(e) => LoginwithEmail(e)}> */}
                  <button type="submit" className="mb-4" onClick={LoginwithEmail} disabled={isSubmitting} >Login</button>
                  {/* </Link> */}

                  {/* <div className="sign-up mt-2">
                  Not registered yet?  Sign Up 
                </div> */}
                </form>
              </div>
              {/* <Tabs
              className="wd-form-login tf-tab"
              selectedIndex={selectedTabIndex}
              onSelect={(index) => setSelectedTabIndex(index)}
            >
              <TabList className="menu-tab">
                <li className="me-4">{selectedDropdownOption}</li>
                <div className="post-form-group">
                  <select
                    className="ct-tab-dropdown"
                    value={selectedDropdownOption}
                    onChange={handleDropdownChange}
                  >
                    <option value="Candidate">Candidate</option>
                    <option value="Institution">Institution</option>
                    <option value="Company">Company</option>
                    <option value="Recruiter">Recruiter</option>
                  </select>
                </div>
              </TabList>

              <div className="content-tab">
                <TabPanel className="inner animation-tab">
                  <Link to="#" className="btn-social" onClick={() => googleSignin()} >
                    <img src={img} alt="images" /> Continue with Google
                  </Link>
                  <form action="/">
                    <div className="ip">
                      <label>Email Address <span>*</span></label>
                      <input
                        type="text"
                        placeholder="Name"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        id="email"
                        name="email"
                        invalid={displays && email === ''}

                      />
                      {displays && !email ? <span className='error_msg_lbl text-red'>Enter Email Address </span> : null}

                    </div>

                    <div className="ip">
                      <label>Password <span>*</span></label>
                      <div className="inputs-group auth-pass-inputgroup">
                        <input
                          type={showPass ? "text" : "password"}
                          className="input-form password-input"
                          placeholder="Password"
                          required
                          id="password-input"
                          name="password"
                          onChange={(e) => setPassword(e.target.value)}
                          value={password}
                          invalid={displays && password === ''}
                        />
                        {displays && !password ? <span className='error_msg_lbl text-red'>Enter Password </span> : null}

                        <Link
                          className={`password-addon ${showPass ? "icon-eye" : "icon-eye-off"
                            }`}
                          id="password-addon"
                          onClick={() => setShowPass(!showPass)}
                        />
                      </div>
                    </div>
                    <div className="group-ant-choice">
                      <Link to="/Forgot-password" className="forgot">
                        Forgot password?
                      </Link>
                    </div>
                    <Link to='/Candidate/homepage' onClick={(e) => LoginwithEmail(e)}>
                      <button type="submit" className="mb-4" >Login</button>
                    </Link>
                    <div className="sign-up">
                      Not registered yet? <Link to="/Register">Sign Up</Link>
                    </div>
                  </form>
                </TabPanel>
                <TabPanel className="inner animation-tab">
                  {selectedDropdownOption === "Institution" && (
                    <div>
                      <Link to="#" className="btn-social" onClick={() => googleSignin()}>
                        <img src={img} alt="images" /> Continue with Google
                      </Link>
                      <form action="/">
                        <div className="ip">
                          <label>Email Address <span>*</span></label>
                          <input
                            type="text"
                            placeholder="Name"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            id="email"
                            name="email"
                            invalid={displays && email === ''}

                          />
                          {displays && !email ? <span className='error_msg_lbl text-red'>Enter Email Address </span> : null}

                        </div>

                        <div className="ip">
                          <label>Password <span>*</span></label>
                          <div className="inputs-group auth-pass-inputgroup">
                            <input
                              type={showPass ? "text" : "password"}
                              className="input-form password-input"
                              placeholder="Password"
                              id="password-input"
                              name="password"
                              required
                              onChange={(e) => setPassword(e.target.value)}
                              value={password}
                              invalid={displays && password === ''}
                            />
                            {displays && !password ? <span className='error_msg_lbl text-red'>Enter Password </span> : null}

                            <Link
                              className={`password-addon ${showPass ? "icon-eye" : "icon-eye-off"
                                }`}
                              id="password-addon"
                              onClick={() => setShowPass(!showPass)}
                            />
                          </div>
                        </div>
                        <div className="group-ant-choice">
                          <Link to="/Forgot-password" className="forgot">
                            Forgot password?
                          </Link>
                        </div>
                        <Link to='/Candidate/homepage' onClick={(e) => LoginwithEmail(e)}>
                          <button type="submit" className="mb-4" >Login</button>
                        </Link>
                        <div className="sign-up">
                          Not registered yet? <Link to="/Register">Sign Up</Link>
                        </div>
                      </form>
                    </div>
                  )}
                  {selectedDropdownOption === "Company" && (
                    <div>
                      <Link to="#" className="btn-social" onClick={() => googleSignin()}>
                        <img src={img} alt="images" /> Continue with Google
                      </Link>
                      <form action="/">
                        <div className="ip">
                          <label>Email Address <span>*</span></label>
                          <input
                            type="text"
                            placeholder="Name"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            id="email"
                            name="email"
                            invalid={displays && email === ''}

                          />
                          {displays && !email ? <span className='error_msg_lbl text-red'>Enter Email Address </span> : null}

                        </div>

                        <div className="ip">
                          <label>Password <span>*</span></label>
                          <div className="inputs-group auth-pass-inputgroup">
                            <input
                              type={showPass ? "text" : "password"}
                              className="input-form password-input"
                              placeholder="Password"
                              id="password-input"
                              name="password"
                              required
                              onChange={(e) => setPassword(e.target.value)}
                              value={password}
                              invalid={displays && password === ''}
                            />
                            {displays && !password ? <span className='error_msg_lbl text-red'>Enter Password </span> : null}

                            <Link
                              className={`password-addon ${showPass ? "icon-eye" : "icon-eye-off"
                                }`}
                              id="password-addon"
                              onClick={() => setShowPass(!showPass)}
                            />
                          </div>
                        </div>
                        <div className="group-ant-choice">
                          <Link to="/Forgot-password" className="forgot">
                            Forgot password?
                          </Link>
                        </div>
                        <Link to='/Candidate/homepage' onClick={(e) => LoginwithEmail(e)}>
                          <button type="submit" className="mb-4" >Login</button>
                        </Link>
                        <div className="sign-up">
                          Not registered yet? <Link to="/Register">Sign Up</Link>
                        </div>
                      </form>
                    </div>
                  )}
                  {selectedDropdownOption === "Recruiter" && (
                    <div>
                      <Link to="#" className="btn-social" onClick={() => googleSignin()}>
                        <img src={img} alt="images" /> Continue with Google
                      </Link>
                      <form action="/">
                        <div className="ip">
                          <label>Email Address <span>*</span></label>
                          <input
                            type="text"
                            placeholder="Name"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            id="email"
                            name="email"
                            invalid={displays && email === ''}

                          />
                          {displays && !email ? <span className='error_msg_lbl text-red'>Enter Email Address </span> : null}

                        </div>

                        <div className="ip">
                          <label>Password <span>*</span></label>
                          <div className="inputs-group auth-pass-inputgroup">
                            <input
                              type={showPass ? "text" : "password"}
                              className="input-form password-input"
                              placeholder="Password"
                              id="password-input"
                              name="password"
                              required
                              onChange={(e) => setPassword(e.target.value)}
                              value={password}
                              invalid={displays && password === ''}
                            />
                            {displays && !password ? <span className='error_msg_lbl text-red'>Enter Password </span> : null}

                            <Link
                              className={`password-addon ${showPass ? "icon-eye" : "icon-eye-off"
                                }`}
                              id="password-addon"
                              onClick={() => setShowPass(!showPass)}
                            />
                          </div>
                        </div>
                        <div className="group-ant-choice">
                          <Link to="/Forgot-password" className="forgot">
                            Forgot password?
                          </Link>
                        </div>
                        <Link to='/Candidate/homepage' onClick={(e) => LoginwithEmail(e)}>
                          <button type="submit" className="mb-4" >Login</button>
                        </Link>
                        <div className="sign-up">
                          Not registered yet? <Link to="/Register">Sign Up</Link>
                        </div>
                      </form>
                    </div>
                  )}
                  {selectedDropdownOption === "Candidate" && (
                    <div>
                      <Link to="#" className="btn-social" onClick={() => googleSignin()}>
                        <img src={img} alt="images" /> Continue with Google
                      </Link>
                      <p className="line-ip">
                        <span>or</span>
                      </p>
                      <form action="/">
                        <div className="ip">
                          <label>Email Address <span>*</span></label>
                          <input
                            type="text"
                            placeholder="Name"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            id="email"
                            name="email"
                            invalid={displays && email === ''}

                          />
                          {displays && !email ? <span className='error_msg_lbl text-red'>Enter Email Address </span> : null}

                        </div>

                        <div className="ip">
                          <label>Password <span>*</span></label>
                          <div className="inputs-group auth-pass-inputgroup">
                            <input
                              type={showPass ? "text" : "password"}
                              className="input-form password-input"
                              placeholder="Password"
                              id="password-input"
                              name="password"
                              required
                              onChange={(e) => setPassword(e.target.value)}
                              value={password}
                              invalid={displays && password === ''}
                            />
                            {displays && !password ? <span className='error_msg_lbl text-red'>Enter Password </span> : null}

                            <Link
                              className={`password-addon ${showPass ? "icon-eye" : "icon-eye-off"
                                }`}
                              id="password-addon"
                              onClick={() => setShowPass(!showPass)}
                            />
                          </div>
                        </div>
                        <div className="group-ant-choice">
                          <Link to="/Forgot-password" className="forgot">
                            Forgot password?
                          </Link>
                        </div>
                        <Link to='/Candidate/homepage' onClick={(e) => LoginwithEmail(e)}>
                          <button type="submit" className="mb-4" >Login</button>
                        </Link>
                        <div className="sign-up">
                          Not registered yet? <Link to="/Register">Sign Up</Link>
                        </div>
                      </form>
                    </div>
                  )}
                </TabPanel>
              </div>
            </Tabs> */}

            </div>
          </div>
        </div>




        {/* <Modal show={flag} onHide={handleClose} centered>
          <Modal.Header >
            <div>
              <h6><span className="fw-bold signUpModal">
                Hi User
              </span></h6>
              <CloseSharpIcon className="pointer" onClick={handleClose} />
            </div>
          </Modal.Header>
          <Modal.Body className="settings">
            <h6>
              <span className="fw-bold signUpModal f-18">
                Verify account by OTP
              </span>{" "}
            </h6>
            <p>Registration data saved, check mail for verification OTP</p>
            <form
              className="auth-register-form mt-1 phoneSignUp pt-2 pb-3"
              style={{ display: flag ? "block" : "none" }}
            >
              <div className="mb-1 d-flex justify-content-center otp-input">
                <OTPInput
                  value={otp}
                  onChange={handleChangeOtp}
                  numInputs={6}
                  // renderInput={(props) => <input {...props} />}
                  renderInput={(props) => <input {...props} style={{ color: 'black', caretColor: 'black' }} />}
                />
              </div>

              <div className="text-center mt-3">
                <div className="countdown-text d-flex justify-content-center">
                  {seconds > 0 || minutes > 0 ? (
                    <p className="me-3">
                      Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
                      {seconds < 10 ? `0${seconds}` : seconds}
                    </p>
                  ) : (
                    <p className="me-3">Didn't recieve code?</p>
                  )}

                  <span
                    disabled={seconds > 0 || minutes > 0}
                    style={{
                      color: seconds > 0 || minutes > 0 ? "#DFE3E8" : "#FF5630",
                    }}
                    onClick={resendOTP}
                    className={seconds > 0 || minutes > 0 ? "" : "pointer"}
                  >
                    Resend OTP
                  </span>
                </div>
                <button type="submit" className="mainBtn">
                  Verify OTP
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal> */}


        {/* {flag && (
        <div
          className="modal fade show modal-md"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="p-2 pt-4 text-center">
                <h4>Hi </h4>
                <h6>
                  <span className="fw-bold signUpModal">
                    Verify account by OTP
                  </span>{" "}
                </h6>
                <p>Registration data saved, check mail for verification OTP</p>
     
              </div>
              <Form
                className="auth-register-form mt-1 phoneSignUp pt-2 pb-3"
                style={{ display: flag ? "block" : "none" }}
              >
                <div className="mb-1 d-flex justify-content-center otp-input">
                  <OTPInput
                    value={otp}
                    onChange={handleChangeOtp}
                    numInputs={4}
                    renderInput={(props) => <input {...props} />}
                  />
                </div>

                <div className="text-center mt-3">
                  <div className="countdown-text d-flex justify-content-center">
                    {seconds > 0 || minutes > 0 ? (
                      <p className="me-3">
                        Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
                        {seconds < 10 ? `0${seconds}` : seconds}
                      </p>
                    ) : (
                      <p className="me-3">Didn't recieve code?</p>
                    )}

                    <span
                      disabled={seconds > 0 || minutes > 0}
                      style={{
                        color: seconds > 0 || minutes > 0 ? "#DFE3E8" : "#FF5630",
                      }}
                      onClick={resendOTP}
                      className={seconds > 0 || minutes > 0 ? "" : "pointer"}
                    >
                      Resend OTP
                    </span>
                  </div>
                  <button type="submit" className="mainBtn">
                    Verify OTP
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      )} */}
        {/* {confimationFlag && (
          <div
            className="modal fade show modal-md"
            tabIndex="-1"
            role="dialog"
            style={{ display: "block" }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="p-2 pt-4 text-center">
                  <h4>Hi </h4>
                  <p>Account exists with the requested email address! but the email is not confirmed.</p>
                  <button type="submit" className="mainBtn">
                    Verify Email
                  </button>
                </div>
              </div>
            </div>
          </div>
        )} */}

        <Modal show={confimationFlag} onHide={handleClose} centered>
          {/* <Modal.Header >
            <div>
              <h6><span className="fw-bold signUpModal">
                Hi User
              </span></h6>
              <CloseSharpIcon className="pointer" onClick={handleClose} />
            </div>
          </Modal.Header> */}
          <Modal.Body className="settings text-center">
            {/* <h4>Hi </h4> */}
            <p>Account exists with the requested email address! but the email is not confirmed.</p>
            <input
              type="text"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              placeholder="Enter Email"
              className="mb-2 form-control Dark-Input-from-group"
            />
            <div className="d-flex align-items-center justify-content-center">
              <div className="khojPrimaryBtn ms-3 text-center">
                <a
                  // className=""
                  onClick={handleSubmitMail}
                  // className={`btn `}
                  style={{ cursor: 'pointer' }}
                >
                  Verify Email
                </a>
              </div>
            </div>

          </Modal.Body>
          {/* <Modal.Footer className='justify-content-center'>
          <div className="khojPrimaryBtn1 ms-3 w-100" >
            <Link to="/" className="">Re-schedule Meeting</Link>
          </div>
        </Modal.Footer> */}
        </Modal>
      </section>
    </>
  );
}

export default SignIn;

// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import img from "../../assets/images/review/google.png";
// import registerGraphic from '../../assets/images/khojgraphics/khoj1.png'
// import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
// import OTPInput from "react-otp-input";
// import { Modal } from "react-bootstrap";
// import fetch_axios from "axios";
// import { useGoogleLogin } from "@react-oauth/google";
// import axios, { PublicKey } from "../../API/axios";
// import toast from "react-hot-toast";
// import CloseSharpIcon from '@mui/icons-material/CloseSharp';
// import { Helmet } from "react-helmet";



// function SignIn() {

// 	const navigate = useNavigate();
// 	const [email, setEmail] = useState('');
// 	const [password, setPassword] = useState('');
// 	const [showPass, setShowPass] = useState(false);
// 	const [displays, setDisplays] = useState(false);
// 	// const [flag, setFlag] = useState(false);
// 	const [confimationFlag, setConfimationFlag] = useState(false);
// 	console.log('confimationFlag', confimationFlag);

// 	const handleClose = () => {
// 		setConfimationFlag(false);
// 	};
// 	const [otp, setOtp] = useState("");
// 	const handleChangeOtp = (otp) => setOtp(otp);

// 	const [minutes, setMinutes] = useState(1)
// 	const [seconds, setSeconds] = useState(30)
// 	const handleSubmitMail = async (e) => {
// 		const body = {
// 			email: email
// 		}
// 		try {
// 			await axios
// 				.post(
// 					`Auth/ConfirmAccountByEmail`, body
// 				)
// 				.then((res) => {
// 					console.log("res", res);
// 					toast.success(res.data.message);
// 					setConfimationFlag(false)
// 				});
// 		} catch (error) {
// 			toast.error(error.response.data.message);
// 		}
// 	};

// 	useEffect(() => {
// 		const interval = setInterval(() => {
// 			if (seconds > 0) {
// 				setSeconds(seconds - 1);
// 			}

// 			if (seconds === 0) {
// 				if (minutes === 0) {
// 					clearInterval(interval);
// 				} else {
// 					setSeconds(59);
// 					setMinutes(minutes - 1);
// 				}
// 			}
// 		}, 1000);

// 		return () => {
// 			clearInterval(interval);
// 		};
// 		// eslint-disable-next-line react-hooks/exhaustive-deps
// 	}, [seconds]);


// 	//  google Api....
// 	const externalLogin = async (responseData) => {
// 		try {
// 			const res = await
// 				axios
// 					.post("/Auth/ContinueWithGoogle", responseData,
// 						{
// 							headers: {
// 								PublicKey,
// 							},
// 						}
// 					);
// 			toast.success(res.data.message)
// 			const userData = res.data.responseData.profile;
// 			localStorage.setItem('entityName', userData.entityName);
// 			localStorage.setItem('email', userData.email);
// 			localStorage.setItem('token', userData.token);
// 			localStorage.setItem('userUID', userData.userUID);
// 			localStorage.setItem('userType', userData.userType);
// 			localStorage.setItem('sessionId', userData.sessionId);
// 			localStorage.setItem('profilPic', userData.userImage);
// 			localStorage.setItem('Module', userData.userType);
// 			if (userData.userType === 'Candidate') {
// 				navigate('/Home')
// 			} else if (userData.userType === 'Institution') {
// 				navigate('/Home')
// 			} else if (userData.userType === 'Company') {
// 				navigate('/Home')
// 			} else if (userData.userType === 'Recruiter') {
// 				navigate('/Home')
// 			}
// 		} catch (error) {
// 			if (error.response && error.response.status === 404) {
// 				toast.error(error.response.data.message)
// 			} else {
// 				toast.error(error.response.data.message)
// 			}
// 		}
// 	};
// 	const googleSignin = useGoogleLogin({
// 		onSuccess: async (tokenResponse) => {
// 			try {
// 				const resp = await fetch_axios.get(
// 					"https://www.googleapis.com/oauth2/v3/userinfo",
// 					{
// 						headers: {
// 							Authorization: `Bearer ${tokenResponse.access_token}`,
// 						},
// 					}
// 				);
// 				const responseData = {
// 					"userType": null,
// 					"email": resp.data.email,
// 					"externalLoginId": resp.data.sub,
// 					"firstName": resp.data.given_name,
// 					"lastName": resp.data.family_name,
// 				};

// 				externalLogin(responseData);
// 			} catch (error) {
// 				console.log(error);
// 			}
// 		},
// 	});

// 	const [isSubmitting, setIsSubmitting] = useState(false);

// 	const LoginwithEmail = async (e) => {
// 		e.preventDefault();
// 		if (isSubmitting) return;

// 		if (!email || !password) {
// 			toast.error("Please enter required fields!");
// 			return;
// 		}

// 		try {
// 			setDisplays(true);
// 			setIsSubmitting(true);
// 			// Step 1: Encode email and password to Base64
// 			const firstPayload = JSON.stringify({ email, password });
// 			const firstEncoded = btoa(firstPayload);



// 			// Step 2: Encode second payload with SecretKey
// 			const secretKey = "uwoETqyKJsOnH7dipuxEVhO+MmWZutnubwQPyLCiJKY="; // Set your Secret Key here
// 			const secondPayload = JSON.stringify({
// 				Result: firstEncoded,
// 				SecretKey: secretKey
// 			});
// 			const secondEncoded = btoa(secondPayload);

// 			// Step 3: Send the second API request
// 			const finalRes = await axios.post("/Auth/Sign_In", { data: secondEncoded }, {
// 				headers: { PublicKey }
// 			});
// 			console.log("finalRes", finalRes);

// 			if (finalRes.data.responseData.emailConfirmed === false) {
// 				setConfimationFlag(true);
// 			} else {
// 				toast.success(finalRes.data.message);
// 				const userData = finalRes.data.responseData.profile;
// 				localStorage.setItem('entityName', userData.entityName);
// 				localStorage.setItem('email', userData.email);
// 				localStorage.setItem('token', userData.token);
// 				localStorage.setItem('userUID', userData.userUID);
// 				localStorage.setItem('userType', userData.userType);
// 				localStorage.setItem('sessionId', userData.sessionId);
// 				localStorage.setItem('profilPic', userData.userImage);
// 				localStorage.setItem('Module', userData.userType);
// 				navigate('/Home');
// 			}
// 		} catch (error) {
// 			console.error("Error:", error);

// 			if (error.response) {
// 				const { status, data } = error.response;
// 				if (error.response.data.responseData?.emailConfirmed === false) {
// 					setConfimationFlag(true);
// 				} else {
// 					toast.error(data.message || "An unexpected error occurred");
// 				}

// 				if (status === 404) console.log("Error: Account not found!");
// 				else if (status === 302) {
// 					console.log("Error: Redirect detected!", error.response.data.responseData?.emailConfirmed);

// 				}
// 				else console.log("Unhandled response status");

// 			} else {
// 				console.log("Error: Network or unknown error");
// 				toast.error("An error occurred. Please try again later.");
// 			}
// 		}
// 		finally {
// 			setIsSubmitting(false); // Re-enable after API is done
// 		}
// 	};


// 	return (
// 		<>
// 			<Helmet>
// 				<title>Login | Jobkikhoj</title>
// 				{/* <meta name="description" content="WeLink Jobs, one of the most trusted job search sites, empowering your career journey. Connect seamlessly for free job posting and social networking." />
//               <meta name="keywords" content="newsfeed, updates, Latest Blogs" />
//               <meta property="og:title" content="WeLink Jobs | Best Social Media Platform For Job Search" />
//               <meta property="og:description" content="WeLink Jobs, one of the most trusted job search sites, empowering your career journey. Connect seamlessly for free job posting and social networking." /> */}
// 				<meta property="og:url" content="https://jobkikhoj.com" />
// 			</Helmet>
// 			<section className="account-section pt-4">
// 				<div className="container">
// 					<div className="row">
// 						<div className="col-md-6 registerGraphics non-login-registerGraphics">
// 							<img src={registerGraphic} width={"80%"} />
// 						</div>
// 						<div className="col-md-6 text-center">
// 							<h4 className="mt-3">Login</h4>
// 							<div className="wd-form-login tf-tab">
// 								<Link to="#" className="btn-social" onClick={() => googleSignin()}>
// 									<img src={img} alt="images" /> Continue with Google
// 								</Link>
// 								<p className="line-ip my-4">
// 									<span>or</span>
// 								</p>
// 								<form action="/">
// 									<div className="ip text-transform-email">
// 										<label>Email Address <span>*</span></label>
// 										<input
// 											type="text"
// 											placeholder="Email Id"
// 											value={email}
// 											onChange={(e) => setEmail(e.target.value)}
// 											id="email"
// 											name="email"
// 											className="Input-SignIn"
// 											invalid={displays && email === ''}

// 										/>
// 										{displays && !email ? <span className='error_msg_lbl text-red'>Enter Email Address </span> : null}

// 									</div>

// 									<div className="ip">
// 										<label>Password <span>*</span></label>
// 										<div className="inputs-group auth-pass-inputgroup">
// 											<input
// 												type={showPass ? "text" : "password"}
// 												className="input-form password-input"
// 												placeholder="Password"
// 												// maxLength={10}
// 												id="password-input"
// 												name="password"
// 												required
// 												onChange={(e) => setPassword(e.target.value)}
// 												//value={password}
// 												invalid={displays && password === ''}
// 											/>
// 											{displays && !password ? <span className='error_msg_lbl text-red'>Enter Password </span> : null}

// 											<Link
// 												className={`password-addon ${showPass ? "icon-eye" : "icon-eye-off"
// 													}`}
// 												id="password-addon"
// 												onClick={() => setShowPass(!showPass)}
// 											/>
// 										</div>
// 									</div>
// 									<div className="group-ant-choice">
// 										<Link to="/Forgot-password" className="forgot">
// 											Forgot password?
// 										</Link>
// 									</div>
// 									{/* <Link to='/Home' onClick={(e) => LoginwithEmail(e)}> */}
// 									<button type="submit" className="mb-4" onClick={LoginwithEmail} disabled={isSubmitting} >Login</button>
// 									{/* </Link> */}

// 									{/* <div className="sign-up mt-2">
//                   Not registered yet?  Sign Up
//                 </div> */}
// 								</form>
// 							</div>
// 							{/* <Tabs
//               className="wd-form-login tf-tab"
//               selectedIndex={selectedTabIndex}
//               onSelect={(index) => setSelectedTabIndex(index)}
//             >
//               <TabList className="menu-tab">
//                 <li className="me-4">{selectedDropdownOption}</li>
//                 <div className="post-form-group">
//                   <select
//                     className="ct-tab-dropdown"
//                     value={selectedDropdownOption}
//                     onChange={handleDropdownChange}
//                   >
//                     <option value="Candidate">Candidate</option>
//                     <option value="Institution">Institution</option>
//                     <option value="Company">Company</option>
//                     <option value="Recruiter">Recruiter</option>
//                   </select>
//                 </div>
//               </TabList>

//               <div className="content-tab">
//                 <TabPanel className="inner animation-tab">
//                   <Link to="#" className="btn-social" onClick={() => googleSignin()} >
//                     <img src={img} alt="images" /> Continue with Google
//                   </Link>
//                   <form action="/">
//                     <div className="ip">
//                       <label>Email Address <span>*</span></label>
//                       <input
//                         type="text"
//                         placeholder="Name"
//                         value={email}
//                         onChange={(e) => setEmail(e.target.value)}
//                         id="email"
//                         name="email"
//                         invalid={displays && email === ''}

//                       />
//                       {displays && !email ? <span className='error_msg_lbl text-red'>Enter Email Address </span> : null}

//                     </div>

//                     <div className="ip">
//                       <label>Password <span>*</span></label>
//                       <div className="inputs-group auth-pass-inputgroup">
//                         <input
//                           type={showPass ? "text" : "password"}
//                           className="input-form password-input"
//                           placeholder="Password"
//                           required
//                           id="password-input"
//                           name="password"
//                           onChange={(e) => setPassword(e.target.value)}
//                           value={password}
//                           invalid={displays && password === ''}
//                         />
//                         {displays && !password ? <span className='error_msg_lbl text-red'>Enter Password </span> : null}

//                         <Link
//                           className={`password-addon ${showPass ? "icon-eye" : "icon-eye-off"
//                             }`}
//                           id="password-addon"
//                           onClick={() => setShowPass(!showPass)}
//                         />
//                       </div>
//                     </div>
//                     <div className="group-ant-choice">
//                       <Link to="/Forgot-password" className="forgot">
//                         Forgot password?
//                       </Link>
//                     </div>
//                     <Link to='/Candidate/homepage' onClick={(e) => LoginwithEmail(e)}>
//                       <button type="submit" className="mb-4" >Login</button>
//                     </Link>
//                     <div className="sign-up">
//                       Not registered yet? <Link to="/Register">Sign Up</Link>
//                     </div>
//                   </form>
//                 </TabPanel>
//                 <TabPanel className="inner animation-tab">
//                   {selectedDropdownOption === "Institution" && (
//                     <div>
//                       <Link to="#" className="btn-social" onClick={() => googleSignin()}>
//                         <img src={img} alt="images" /> Continue with Google
//                       </Link>
//                       <form action="/">
//                         <div className="ip">
//                           <label>Email Address <span>*</span></label>
//                           <input
//                             type="text"
//                             placeholder="Name"
//                             value={email}
//                             onChange={(e) => setEmail(e.target.value)}
//                             id="email"
//                             name="email"
//                             invalid={displays && email === ''}

//                           />
//                           {displays && !email ? <span className='error_msg_lbl text-red'>Enter Email Address </span> : null}

//                         </div>

//                         <div className="ip">
//                           <label>Password <span>*</span></label>
//                           <div className="inputs-group auth-pass-inputgroup">
//                             <input
//                               type={showPass ? "text" : "password"}
//                               className="input-form password-input"
//                               placeholder="Password"
//                               id="password-input"
//                               name="password"
//                               required
//                               onChange={(e) => setPassword(e.target.value)}
//                               value={password}
//                               invalid={displays && password === ''}
//                             />
//                             {displays && !password ? <span className='error_msg_lbl text-red'>Enter Password </span> : null}

//                             <Link
//                               className={`password-addon ${showPass ? "icon-eye" : "icon-eye-off"
//                                 }`}
//                               id="password-addon"
//                               onClick={() => setShowPass(!showPass)}
//                             />
//                           </div>
//                         </div>
//                         <div className="group-ant-choice">
//                           <Link to="/Forgot-password" className="forgot">
//                             Forgot password?
//                           </Link>
//                         </div>
//                         <Link to='/Candidate/homepage' onClick={(e) => LoginwithEmail(e)}>
//                           <button type="submit" className="mb-4" >Login</button>
//                         </Link>
//                         <div className="sign-up">
//                           Not registered yet? <Link to="/Register">Sign Up</Link>
//                         </div>
//                       </form>
//                     </div>
//                   )}
//                   {selectedDropdownOption === "Company" && (
//                     <div>
//                       <Link to="#" className="btn-social" onClick={() => googleSignin()}>
//                         <img src={img} alt="images" /> Continue with Google
//                       </Link>
//                       <form action="/">
//                         <div className="ip">
//                           <label>Email Address <span>*</span></label>
//                           <input
//                             type="text"
//                             placeholder="Name"
//                             value={email}
//                             onChange={(e) => setEmail(e.target.value)}
//                             id="email"
//                             name="email"
//                             invalid={displays && email === ''}

//                           />
//                           {displays && !email ? <span className='error_msg_lbl text-red'>Enter Email Address </span> : null}

//                         </div>

//                         <div className="ip">
//                           <label>Password <span>*</span></label>
//                           <div className="inputs-group auth-pass-inputgroup">
//                             <input
//                               type={showPass ? "text" : "password"}
//                               className="input-form password-input"
//                               placeholder="Password"
//                               id="password-input"
//                               name="password"
//                               required
//                               onChange={(e) => setPassword(e.target.value)}
//                               value={password}
//                               invalid={displays && password === ''}
//                             />
//                             {displays && !password ? <span className='error_msg_lbl text-red'>Enter Password </span> : null}

//                             <Link
//                               className={`password-addon ${showPass ? "icon-eye" : "icon-eye-off"
//                                 }`}
//                               id="password-addon"
//                               onClick={() => setShowPass(!showPass)}
//                             />
//                           </div>
//                         </div>
//                         <div className="group-ant-choice">
//                           <Link to="/Forgot-password" className="forgot">
//                             Forgot password?
//                           </Link>
//                         </div>
//                         <Link to='/Candidate/homepage' onClick={(e) => LoginwithEmail(e)}>
//                           <button type="submit" className="mb-4" >Login</button>
//                         </Link>
//                         <div className="sign-up">
//                           Not registered yet? <Link to="/Register">Sign Up</Link>
//                         </div>
//                       </form>
//                     </div>
//                   )}
//                   {selectedDropdownOption === "Recruiter" && (
//                     <div>
//                       <Link to="#" className="btn-social" onClick={() => googleSignin()}>
//                         <img src={img} alt="images" /> Continue with Google
//                       </Link>
//                       <form action="/">
//                         <div className="ip">
//                           <label>Email Address <span>*</span></label>
//                           <input
//                             type="text"
//                             placeholder="Name"
//                             value={email}
//                             onChange={(e) => setEmail(e.target.value)}
//                             id="email"
//                             name="email"
//                             invalid={displays && email === ''}

//                           />
//                           {displays && !email ? <span className='error_msg_lbl text-red'>Enter Email Address </span> : null}

//                         </div>

//                         <div className="ip">
//                           <label>Password <span>*</span></label>
//                           <div className="inputs-group auth-pass-inputgroup">
//                             <input
//                               type={showPass ? "text" : "password"}
//                               className="input-form password-input"
//                               placeholder="Password"
//                               id="password-input"
//                               name="password"
//                               required
//                               onChange={(e) => setPassword(e.target.value)}
//                               value={password}
//                               invalid={displays && password === ''}
//                             />
//                             {displays && !password ? <span className='error_msg_lbl text-red'>Enter Password </span> : null}

//                             <Link
//                               className={`password-addon ${showPass ? "icon-eye" : "icon-eye-off"
//                                 }`}
//                               id="password-addon"
//                               onClick={() => setShowPass(!showPass)}
//                             />
//                           </div>
//                         </div>
//                         <div className="group-ant-choice">
//                           <Link to="/Forgot-password" className="forgot">
//                             Forgot password?
//                           </Link>
//                         </div>
//                         <Link to='/Candidate/homepage' onClick={(e) => LoginwithEmail(e)}>
//                           <button type="submit" className="mb-4" >Login</button>
//                         </Link>
//                         <div className="sign-up">
//                           Not registered yet? <Link to="/Register">Sign Up</Link>
//                         </div>
//                       </form>
//                     </div>
//                   )}
//                   {selectedDropdownOption === "Candidate" && (
//                     <div>
//                       <Link to="#" className="btn-social" onClick={() => googleSignin()}>
//                         <img src={img} alt="images" /> Continue with Google
//                       </Link>
//                       <p className="line-ip">
//                         <span>or</span>
//                       </p>
//                       <form action="/">
//                         <div className="ip">
//                           <label>Email Address <span>*</span></label>
//                           <input
//                             type="text"
//                             placeholder="Name"
//                             value={email}
//                             onChange={(e) => setEmail(e.target.value)}
//                             id="email"
//                             name="email"
//                             invalid={displays && email === ''}

//                           />
//                           {displays && !email ? <span className='error_msg_lbl text-red'>Enter Email Address </span> : null}

//                         </div>

//                         <div className="ip">
//                           <label>Password <span>*</span></label>
//                           <div className="inputs-group auth-pass-inputgroup">
//                             <input
//                               type={showPass ? "text" : "password"}
//                               className="input-form password-input"
//                               placeholder="Password"
//                               id="password-input"
//                               name="password"
//                               required
//                               onChange={(e) => setPassword(e.target.value)}
//                               value={password}
//                               invalid={displays && password === ''}
//                             />
//                             {displays && !password ? <span className='error_msg_lbl text-red'>Enter Password </span> : null}

//                             <Link
//                               className={`password-addon ${showPass ? "icon-eye" : "icon-eye-off"
//                                 }`}
//                               id="password-addon"
//                               onClick={() => setShowPass(!showPass)}
//                             />
//                           </div>
//                         </div>
//                         <div className="group-ant-choice">
//                           <Link to="/Forgot-password" className="forgot">
//                             Forgot password?
//                           </Link>
//                         </div>
//                         <Link to='/Candidate/homepage' onClick={(e) => LoginwithEmail(e)}>
//                           <button type="submit" className="mb-4" >Login</button>
//                         </Link>
//                         <div className="sign-up">
//                           Not registered yet? <Link to="/Register">Sign Up</Link>
//                         </div>
//                       </form>
//                     </div>
//                   )}
//                 </TabPanel>
//               </div>
//             </Tabs> */}

// 						</div>
// 					</div>
// 				</div>




// 				{/* <Modal show={flag} onHide={handleClose} centered>
//           <Modal.Header >
//             <div>
//               <h6><span className="fw-bold signUpModal">
//                 Hi User
//               </span></h6>
//               <CloseSharpIcon className="pointer" onClick={handleClose} />
//             </div>
//           </Modal.Header>
//           <Modal.Body className="settings">
//             <h6>
//               <span className="fw-bold signUpModal f-18">
//                 Verify account by OTP
//               </span>{" "}
//             </h6>
//             <p>Registration data saved, check mail for verification OTP</p>
//             <form
//               className="auth-register-form mt-1 phoneSignUp pt-2 pb-3"
//               style={{ display: flag ? "block" : "none" }}
//             >
//               <div className="mb-1 d-flex justify-content-center otp-input">
//                 <OTPInput
//                   value={otp}
//                   onChange={handleChangeOtp}
//                   numInputs={6}
//                   // renderInput={(props) => <input {...props} />}
//                   renderInput={(props) => <input {...props} style={{ color: 'black', caretColor: 'black' }} />}
//                 />
//               </div>

//               <div className="text-center mt-3">
//                 <div className="countdown-text d-flex justify-content-center">
//                   {seconds > 0 || minutes > 0 ? (
//                     <p className="me-3">
//                       Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
//                       {seconds < 10 ? `0${seconds}` : seconds}
//                     </p>
//                   ) : (
//                     <p className="me-3">Didn't recieve code?</p>
//                   )}

//                   <span
//                     disabled={seconds > 0 || minutes > 0}
//                     style={{
//                       color: seconds > 0 || minutes > 0 ? "#DFE3E8" : "#FF5630",
//                     }}
//                     onClick={resendOTP}
//                     className={seconds > 0 || minutes > 0 ? "" : "pointer"}
//                   >
//                     Resend OTP
//                   </span>
//                 </div>
//                 <button type="submit" className="mainBtn">
//                   Verify OTP
//                 </button>
//               </div>
//             </form>
//           </Modal.Body>
//         </Modal> */}


// 				{/* {flag && (
//         <div
//           className="modal fade show modal-md"
//           tabIndex="-1"
//           role="dialog"
//           style={{ display: "block" }}
//         >
//           <div className="modal-dialog modal-dialog-centered" role="document">
//             <div className="modal-content">
//               <div className="p-2 pt-4 text-center">
//                 <h4>Hi </h4>
//                 <h6>
//                   <span className="fw-bold signUpModal">
//                     Verify account by OTP
//                   </span>{" "}
//                 </h6>
//                 <p>Registration data saved, check mail for verification OTP</p>

//               </div>
//               <Form
//                 className="auth-register-form mt-1 phoneSignUp pt-2 pb-3"
//                 style={{ display: flag ? "block" : "none" }}
//               >
//                 <div className="mb-1 d-flex justify-content-center otp-input">
//                   <OTPInput
//                     value={otp}
//                     onChange={handleChangeOtp}
//                     numInputs={4}
//                     renderInput={(props) => <input {...props} />}
//                   />
//                 </div>

//                 <div className="text-center mt-3">
//                   <div className="countdown-text d-flex justify-content-center">
//                     {seconds > 0 || minutes > 0 ? (
//                       <p className="me-3">
//                         Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
//                         {seconds < 10 ? `0${seconds}` : seconds}
//                       </p>
//                     ) : (
//                       <p className="me-3">Didn't recieve code?</p>
//                     )}

//                     <span
//                       disabled={seconds > 0 || minutes > 0}
//                       style={{
//                         color: seconds > 0 || minutes > 0 ? "#DFE3E8" : "#FF5630",
//                       }}
//                       onClick={resendOTP}
//                       className={seconds > 0 || minutes > 0 ? "" : "pointer"}
//                     >
//                       Resend OTP
//                     </span>
//                   </div>
//                   <button type="submit" className="mainBtn">
//                     Verify OTP
//                   </button>
//                 </div>
//               </Form>
//             </div>
//           </div>
//         </div>
//       )} */}
// 				{/* {confimationFlag && (
//           <div
//             className="modal fade show modal-md"
//             tabIndex="-1"
//             role="dialog"
//             style={{ display: "block" }}
//           >
//             <div className="modal-dialog modal-dialog-centered" role="document">
//               <div className="modal-content">
//                 <div className="p-2 pt-4 text-center">
//                   <h4>Hi </h4>
//                   <p>Account exists with the requested email address! but the email is not confirmed.</p>
//                   <button type="submit" className="mainBtn">
//                     Verify Email
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )} */}

// 				<Modal show={confimationFlag} onHide={handleClose} centered>
// 					{/* <Modal.Header >
//             <div>
//               <h6><span className="fw-bold signUpModal">
//                 Hi User
//               </span></h6>
//               <CloseSharpIcon className="pointer" onClick={handleClose} />
//             </div>
//           </Modal.Header> */}
// 					<Modal.Body className="settings text-center">
// 						{/* <h4>Hi </h4> */}
// 						<p>Account exists with the requested email address! but the email is not confirmed.</p>
// 						<input
// 							type="text"
// 							value={email}
// 							onChange={(e) => {
// 								setEmail(e.target.value);
// 							}}
// 							placeholder="Enter Email"
// 							className="mb-2 form-control Dark-Input-from-group"
// 						/>
// 						<div className="d-flex align-items-center justify-content-center">
// 							<div className="khojPrimaryBtn ms-3 text-center">
// 								<a
// 									// className=""
// 									onClick={handleSubmitMail}
// 									// className={`btn `}
// 									style={{ cursor: 'pointer' }}
// 								>
// 									Verify Email
// 								</a>
// 							</div>
// 						</div>

// 					</Modal.Body>
// 					{/* <Modal.Footer className='justify-content-center'>
//           <div className="khojPrimaryBtn1 ms-3 w-100" >
//             <Link to="/" className="">Re-schedule Meeting</Link>
//           </div>
//         </Modal.Footer> */}
// 				</Modal>
// 			</section>
// 		</>
// 	);
// }

// export default SignIn;
